import { css, styled } from 'styled-components';
import { Box, CaretRightIcon, Heading, Input, RadioGroup, Text } from '@cof/plastic-components';
import PropTypes from 'prop-types';

export const SmallCaretRightIcon = styled(CaretRightIcon)`
    ${({ theme }: any) => css`
        margin-right: 1.2rem;
        width: 1.4rem;
        color: ${theme.colors.capitalOne.teal600};
    `};
`;

export const DefaultText = styled(Text)`
    font-weight: 500;
`;

export const FullInputWidth = styled(Input)`
    width: 100%;
`;

export const GridRadioGroup = styled(RadioGroup)`
    ${({ theme }: any) => css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: ${theme.space.xs};
        width: 100%;
        padding-bottom: ${theme.space.xs};
        ${theme.breakpoints.mq.mobileMax} {
            grid-template-columns: repeat(2, 1fr);
        }
    `};
`;

export const InputWrapper = styled(Box)`
    ${({ theme }: any) => css`
        margin-top: ${theme.space.sm};
        margin-bottom: ${theme.space.xs};
    `};
`;

export const SingleFormWrapper = styled(Box)`
    ${({ theme }: any) => css`
        background: ${theme.colors.global.white};
        margin-bottom: 32px;
        border-radius: 4px;
        padding: 2.4rem ${theme.space.sm};
        ${theme.breakpoints.mq.tabletMin} {
            padding: ${theme.space.lg};
        }
    `};
`;

export const AsosSectionHeading = ({ children }: any) => (
    <Box backgroundColor={'global.grey100'}>
        <Heading level="3" padding={'sm'}>
            {children}
        </Heading>
    </Box>
);

AsosSectionHeading.propTypes = {
    children: PropTypes.node
};
